module.exports = __webpack_public_path__ + "static/media/helpicon.20d199f3.svg";